<template>
    <div class="content_box">
        <div class="top">
            <div class="title">
                <span>设备管理</span>
            </div>&nbsp;&nbsp;
            <el-select v-model="region" placeholder="请选择" class="region-select" @change="regionChanged">
                <el-option label="美洲数据中心" value="us"></el-option>
                <el-option label="中国数据中心" value="cn"></el-option>
                <el-option label="欧洲数据中心" value="eu"></el-option>
                <el-option label="亚太数据中心" value="ap"></el-option>
            </el-select>
        </div>
        <div class="second">
            <div class="left">
                <p class="left_title">产品名称：</p>
                <el-select v-model="searchData.productKey" placeholder="全部产品" class="region-select" clearable
                    @change="productChanged" size="small" style="width: 100%;">
                    <el-option v-for="item in productList" :key="item.productKey" :label="item.name"
                        :value="item.productKey"></el-option>
                </el-select>
            </div>
            <div class="right">
                <el-row class="count">
                    <el-col :span="8">
                        <div>
                            <p class="right_title">设备总数</p>
                            <p class="right_text">{{totalAll}}</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div>
                            <p class="right_title color1">激活设备</p>
                            <p class="right_text">{{totalActive}}</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div>
                            <p class="right_title color2">当前在线</p>
                            <p class="right_text">{{totalOnline}}</p>
                        </div>
                    </el-col>
                </el-row>
                <div class="refresh">
                    <el-button type="text" @click="refresh">
                        <i class="el-icon-refresh"></i><span>刷新</span>
                    </el-button>
                </div>
            </div>
        </div>
        <div class="area">
            <div class="content">
                <p class="divece_title">设备列表</p><br>
                <div class="search_box">
                    <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="120px">
                        <el-form-item label="DeviceName" class="form_item">
                            <el-input placeholder="请输入" v-model="searchData.deviceName"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.status" placeholder="状态">
                                <el-option label="全部状态" :value="-1"></el-option>
                                <el-option label="在线" :value="1"></el-option>
                                <el-option label="离线" :value="3"></el-option>
                                <el-option label="未激活" :value="0"></el-option>
                                <el-option label="已禁用" :value="8"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="设备激活时间" class="form_item date_picker">
                            <DatePicker :date="activeTime" :clearable="true" @dateSelect="activeDateSelect"></DatePicker>
                        </el-form-item>
                        <el-form-item label="最后上线时间" class="form_item date_picker">
                            <DatePicker :date="createTime" :clearable="true" @dateSelect="dateSelect"></DatePicker>
                        </el-form-item>
                        <el-form-item>
                            <div class="button search" @click="search">
                                <span>查询</span>
                            </div>
                            <div class="button search white" @click="init">
                                <span>重置</span>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <el-table :data="deviceList" :fit="true" highlight-current-row style="width:100%" @sort-change="sortChange" :default-sort = "{prop: 'onlineTime', order: 'descending'}">
                    <el-table-column prop="deviceName" label="DeviceName" width="230" >
                        <template slot-scope="scope">
                            <div class="btn">
                                <div class="button text" @click.stop="goDetail(scope.row)">
                                    <span>{{scope.row.deviceName}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="产品名称" min-width="160">
                        <template slot-scope="scope">
                            <span>{{ scope.row.productName || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="设备状态">
                        <template slot-scope="scope">
                            <span class="status1" v-if="scope.row.status == 1">在线</span>
                            <span class="status3" v-if="scope.row.status == 3">离线</span>
                            <span class="status2" v-if="scope.row.status == 0">未激活</span>
                            <span v-if="scope.row.status == 8">已禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activeTime"  label="设备激活时间" min-width="160">
                        <template slot-scope="scope">
                            <span>{{ scope.row.activeTime > 0 ? formDate(scope.row.activeTime) : '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="onlineTime" sortable label="最后上线时间" min-width="160">
                        <template slot-scope="scope">
                            <span>{{ scope.row.onlineTime > 0 ? formDate(scope.row.onlineTime) : '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ali_user_id" label="操作" width="150">
                        <template slot-scope="scope">
                            <div class="btn">
                                <div class="button text" v-if="roleCheck('104-102-101-102')" @click="initNetwork(scope.row)">
                                    <span>重置网络</span>
                                </div>
                                <div class="button text" @click.stop="goDetail(scope.row)">
                                    <span>查看</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
                <Tip ref="initTip" :msg="initNetworkMsg" title="重置设备网络">
                    <template v-slot:confirm_btn>
                        <div class="button del" @click="initNetworkComfirm">
                            <span>确定</span>
                        </div>
                    </template>
                </Tip>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'device-manage',
    data() {
        return {
            region: 'us',
            searchData: {
                page_size: 10,
                page: 1,
                productKey: '',
                status: -1,
            },
            createTime: [],
            activeTime:[],
            total: 0,
            totalAll: '',
            totalOnline: '',
            totalActive: '',
            deviceList: [],
            productList: [],
            initNetworkMsg: '',
            initNetworkData: {}
        };
    },
    created() {
        if (!this.$route.query.region) {
            this.$router.replace('?region=us');
        }
        this.region = this.$route.query.region || this.region;
        this.getIotProductList();
        this.getIotDeviceList();
        this.getdeviceAllNum();

    },
    watch: {
        createTime: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchData.start_time = nTime[0];
                this.searchData.end_time = nTime[1];
            } else {
                this.searchData.start_time = 0;
                this.searchData.end_time = 0;
            }
        },
        activeTime: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchData.start_time_active = nTime[0];
                this.searchData.end_time_active = nTime[1];
            } else {
                this.searchData.start_time_active = 0;
                this.searchData.end_time_active = 0;
            }
        }
    },
    methods: {
        init() {
            this.searchData = {
                page_size: 10,
                page: 1,
                deviceName: '',
                status: -1,
                start_time_active:'',
                end_time_active:'',
                end_time: '',
                start_time: '',
                asc: false,
                productKey:this.productKey
            };
            this.createTime = [];
            this.activeTime = [];
        },
        dateSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        activeDateSelect(date) {
            this.activeTime = date ? [...date] : '';
        },
        regionChanged(val) {
            this.region = val;
            this.$router.replace('?region=' + val);
            this.deviceList = [];
            this.total = 0;
            this.search();
        },
        productChanged(val) {
            this.productKey = val;
            this.deviceList = [];
            this.total = 0;
            this.search();
        },
        search() {
            this.searchData.page = 1;
            this.getIotDeviceList();
            this.getdeviceAllNum();
        },
        getIotDeviceList() {
            this.api.getIotDeviceList(this.searchData).then(data => {
                this.deviceList = data.data.result;
                this.total = data.data.total;
               // this.totalAll = data.data.totalAll;
              //  this.totalActive = data.data.totalActive;
               // this.totalOnline = data.data.totalOnline;
            })
        },
        getdeviceAllNum(){
           this.api.getdeviceAllNum(this.searchData).then(data => {
                // 注意：该接口只返回 totalAll/totalActive/totalOnline，无 total 字段，
                // 此处不可覆盖 this.total（总数由 getIotDeviceList 返回），否则分页总数丢失
                this.totalAll = data.data.totalAll;
                this.totalActive = data.data.totalActive;
                this.totalOnline = data.data.totalOnline;
            })
 
        },



        goDetail(row) {
            if (window.h5sdk) {
                this.$router.push({ name: 'device-detail', params: { id: row.iotId }, query: { region: this.region, deviceName: row.deviceName, productKey: row.productKey } });
                return;
            }
            const page = this.$router.resolve({
                name: 'device-detail',
                params: {
                    id: row.iotId
                },
                query: {
                    region: this.region, 
                    deviceName: row.deviceName,
                    productKey: row.productKey
                }
            });
            window.open(page.href, "_blank");
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getIotDeviceList();
        },
        getIotProductList() {
            this.api.getIotProductList().then(data => {
                this.productList = data.data.result;
                this.productList.unshift({'productKey':'','name':'全部产品'})
            })
        },
        refresh() {
            this.search();
        },
        sortChange(sort) {
            if(sort.prop == 'onlineTime') {
                if(!sort.order || sort.order == 'descending'){
                    this.searchData.asc = false;
                }else{
                    this.searchData.asc = true;
                }
            }
            this.search();
        },
        initNetwork(item) {
            this.initNetworkData = {
                region: item.region,
                iotId: item.iotId
            };
            this.initNetworkMsg = '确认重置设备网络：' + item.deviceName;
            this.$refs.initTip.show = true;
            // this.initDeviceNetwork({region: item.region})
        },
        initNetworkComfirm() {
            this.api.initDeviceNetwork(this.initNetworkData).then(data => {
                this.$message.success('操作成功!');
                this.$refs.initTip.show = false;
            })
        }
    }
};
</script>

<style lang="less" scoped>
.content_box {
    padding: 0;

}

/deep/.top {
    .flexLayout(space-between);
    padding: 20px;
    background-color: @colorWhite;

    .el-input__inner {
        height: 32px;
        line-height: 32px;
    }

    .el-input__icon {
        line-height: 32px;
    }

    @media (max-width: 768px) {
        .el-input__inner {
            height: 28px;
            line-height: 28px;
        }

        .el-input__icon {
            line-height: 28px;
        }
    }
}

.second {
    margin: 20px;
    display: flex;
    align-items: center;
    height: 120px;

    .left {
        padding: 20px 40px;
        background-color: @colorWhite;
        border-radius: 24px;
        width: 250px;
        height: 60%;
        .left_title {
            padding-bottom: 5px;
        }
    }

    .right {
        margin-left: 20px;
        padding: 20px 0px 20px 80px;
        background-color: @colorWhite;
        border-radius: 24px;
        height: 60%;
        display: flex;
        flex: 1;
        .count {
            width: 90%;

            .right_title {
                padding: 5px 0;
            }

            .right_text {
                font-weight: 600;
            }
        }

        .color1 {
            color: @colorBlue2;
        }

        .color2 {
            color: #00D6B9;
        }
    }
}

.area {
    padding: 0 20px 20px 20px;
    height: calc(100% - 230px);
    box-sizing: border-box;

    .divece_title {
        font-size: 16px;
        font-weight: 600;
    }

    .status1 {
        color: #00D6B9;
    }

    .status2 {
        color: #F8AF0C;
    }

    .status3 {
        color: #EB534B;
    }

    @media (max-width: 768px) {
        .el-form.form-list .el-form-item {
            margin-right: 0 !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/iot/device-manage/device-manage.vue